import React, { Component } from "react";

class RadioField extends Component {
  render() {
    const {
      register,
      errors,
      label,
      name,
      rules,
      disabled,
      className,
      styles,
      labelClassName,
      labelStyles,
    } = this.props;

    return (
      <div className={`flex items-center ${className}`}>
        <input
          {...register(name, rules)}
          type="radio"
          disabled={disabled}
          className={`h-3 w-3 text-blue-600 border-gray-300 rounded-full focus:ring-blue-500 ${disabled ? 'cursor-not-allowed opacity-50' : ''}`}
          style={styles}
          aria-invalid={!!errors[name]}
          aria-describedby={errors[name] ? `${name}-error` : undefined}
        />
        <label
          htmlFor={name}
          className={`ml-2 form-label font-bold ${labelClassName}`}
          style={labelStyles}
        >
          {rules?.required && <span className="text-red-500">*</span>} {label}
        </label>
        {errors[name] && (
          <span id={`${name}-error`} className="text-red-500 text-sm mt-1">
            {errors[name].message}
          </span>
        )}
      </div>
    );
  }
}

export default RadioField;